export const DonationTabs = {
    Donate: 0,
    Gift: 1
}